export const FILTER_OPTIONS = [
    {
        id: "energy",
        label: "Energía"
    },
    {
        id: "caja",
        label: "Caja de cambio"
    },
    {
        id: "presupuest",
        label: "Presupuesto"
    }
];

export const EXTRA_CREDIT_DATA = "\n\nSimulación corresponde a producto Compra Inteligente operado por Autofin S.A., con un 40% de pie, 48 cuotas y cuotón de 30% valor del vehiculo (cuota n° 49 VFMG)"

export const UNIQUE_COLORS = {
    P0WP: 'BLANCO',
    M09V: 'NEGRO PERLA',
    'M09V/DZK02': 'NEGRO PERLA / BLANCO',
    'M09V/DZK03': 'NEGRO PERLA/BLANCO',
    M0F4: 'GRIS ARTENSE',
    'M0F4/DZK02': 'GRIS ARTENSE / BLANCO',
    'M0F4/DZK12': 'GRIS ARTENSE / NEGRO',
    'M0HZ/DZK03': 'AZUL KANDINSKY / BLANCO',
    'M0HZ/DZK13': 'AZUL KANDINSKY / NEGRO',
    M0PH: 'BEIGE CHRYSTAL PEARL',
    'M0PH/DZK03': 'BEIGE CHRYSTAL PEARL / BLANCO',
    'M0PH/DZK13': 'BEIGE CHRYSTAL PEARL / NEGRO',
    'M0PY/DZK03': 'ROJO RUBI / BLANCO',
    'M0PY/DZK13': 'ROJO RUBI / NEGRO',
    M0VL: 'GRIS PLATINUM',
    'M0VL/DZK02': 'GRIS PLATINUM / BLANCO',
    'M0VL/DZK12': 'GRIS PLATINUM / NEGRO',
    'M6FC/DZK13': 'BLANCO NACAR / NEGRO',
    'M6FC/DZK12': 'BLANCO NACAR / NEGRO',
    M0KU: 'AZUL ENCRE',
    M6N9: 'BLANCO NACAR',
    M06L: 'AZUL OSCURO',
    'M09V/DJD35': 'NEGRO PERLA / BLANCO',
    'M0P1/DJD35': 'GRIS GRAFITO / BLANCO',
    'P0WP/DJD20': 'BLANCO / NEGRO',
};

export const COLORS = {
    '1CM3A4KMNKJRA0_FEEL_PACK': {
        P0WP: 'BLANCO',
    },
    '1SD3SYNESFJRA0_GRAND_CHIC': {
        M09V: 'NEGRO PERLA',
        'M9V/DZK02': 'NEGRO PERLA / BLANCO',
        'M0F4/DZK02': 'GRIS ARTENSE / BLANCO',
        M0F4: 'GRIS ARTENSE',
        'M0F4/DZK12': 'GRIS ARTENSE / NEGRO',
        'M0HZ/DZK03': 'AZUL KANDINSKY / BLANCO',
        'M0PH/DZK03': 'BEIGE CHRYSTAL PEARL / BLANCO',
        'M0PH/DZK13': 'BEIGE CHRYSTAL PEARL / NEGRO',
        'M0HZ/DZK13': 'AZUL KANDINSKY / NEGRO',
        'M0PY/DZK03': 'ROJO RUBI / BLANCO',
        'M0PY/DZK13': 'ROJO RUBI / NEGRO',
        M0VL: 'GRIS PLATINUM',
        'M0VL/DZK12': 'GRIS PLATINUM / NEGRO',
        'M0VL/DZK02': 'GRIS PLATINUM / BLANCO',
        'M6FC/DZK13': 'BLANCO NACAR / NEGRO',
    },
    '1SD3SYNMMKJRA0_SOCHIC': {
        M09V: 'NEGRO PERLA',
        'M0VL/DZK02': 'GRIS PLATINUM / BLANCO',
        'M6FC/DZK12': 'BLANCO NACAR / NEGRO',
        'M0VL/DZK12': 'GRIS PLATINIUM / NEGRO',
        M0VL: 'GRIS PLATINIUM',
        'M0PY/DZK13': 'ROJO RUBI / NEGRO',
        'M0PY/DZK03': 'ROJO RUBI / BLANCO',
        'M0PH/DZK13': 'BEIGE CHRYSTAL PEARL / NEGRO',
        'M0F4/DZK12': 'GRIS ARTENSE / NEGRO',
        'M0HZ/DZK03': 'AZUL KANDINSKY / BLANCO',
        'M0HZ/DZK13': 'AZUL KANDINSKY / NEGRO',
        'M0PH/DZK03': 'BEIGE CHRYSTAL PEARL / BLANCO',
        M0F4: 'GRIS ARTENSE',
        'M0F4/DZK02': 'GRIS ARTENSE / BLANCO',
        'M09V/DZK02': 'NEGRO PERLA / BLANCO',
    },
    '1SD3SYNNQ1JRA0_GRAND_CHIC': {
        M09V: 'NEGRO PERLA',
        'M09V/DZK03': 'NEGRO PERLA/BLANCO',
        M0F4: 'GRIS ARTENSE',
        'M0F4/DZK12': 'GRIS ARTENSE/NEGRO',
        'M0F4/DZK02': 'GRIS ARTENSE/BLANCO',
        'M0PH/DZK03': 'BEIGE CHRYSTAL PEARL / BLANCO',
        'M0HZ/DZK03': 'AZUL KANDINSKY / BLANCO',
        'M0PY/DZK03': 'ROJO RUBI / BLANCO',
        'M0HZ/DZK13': 'AZUL KANDINSKY / NEGRO',
        'M0PH/DZK13': 'BEIGE CHRYSTAL PEARL / NEGRO',
        'M0PY/DZK13': 'ROJO RUBI / NEGRO',
        M0VL: 'GRIS PLATINIUM',
        'M0VL/DZK02': 'GRIS PLATINIUM / BLANCO',
        'M0VL/DZK12': 'GRIS PLATINIUM / NEGRO',
        'M6FC/DZK13': 'BLANCO NACAR / NEGRO',
    },
    '1SD3SYNNQ1JRA0_SOCHIC': {
        M09V: 'NEGRO PERLA',
        'M09V/DZK03': 'NEGRO PERLA/BLANCO',
        M0F4: 'GRIS ARTENSE',
        'M0F4/DZK02': 'GRIS ARTENSE/BLANCO',
        'M0F4/DZK12': 'GRIS ARTENSE/NEGRO',
        'M0PH/DZK03': 'BEIGE CHRYSTAL PEARL / BLANCO',
        'M0HZ/DZK03': 'AZUL KANDINSKY / BLANCO',
        'M0HZ/DZK13': 'AZUL KANDINSKY / NEGRO',
        'M0PH/DZK13': 'BEIGE CHRYSTAL PEARL / NEGRO',
        'M0PY/DZK03': 'ROJO RUBI / BLANCO',
        'M0PY/DZK13': 'ROJO RUBI / NEGRO',
        M0VL: 'GRIS PLATINIUM',
        'M0VL/DZK02': 'GRIS PLATINIUM / BLANCO',
        'M0VL/DZK12': 'GRIS PLATINIUM / NEGRO',
        'M6FC/DZK13': 'BLANCO NACAR / NEGRO',
    },
    '1SD3SYTESFJRL0_LOUVRE': {
        'M0VL/DZK12': 'GRIS PLATINIUM / NEGRO',
        'M0PH/DZK13': 'BEIGE CHRYSTAL PEARL / NEGRO',
        'M0F4/DZK12': 'GRIS ARTENSE / NEGRO',
        M09V: 'NEGRO PERLA',
    },
    '1SD3SYTNQ1JRL0_LOUVRE': {
        M09V: 'NEGRO PERLA',
        'M0F4/DZK12': 'GRIS ARTENSE / NEGRO',
        'M0PH/DZK13': 'BEIGE CHRYSTAL PEARL / NEGRO',
        'M0VL/DZK12': 'GRIS PLATINIUM / NEGRO',
    },
    '1SX8SUKKA1JRA0_BECHIC': {
        M09V: 'NEGRO PERLA',
        M0F4: 'GRIS ARTENSE',
        M0PH: 'BEIGE CHRYSTAL PEARL',
        M0VL: 'GRIS PLATINIUM',
        M6N9: 'BLANCO NACAR',
    },
    '1SX8SUNKA1JRA0_OPERA': {
        M09V: 'NEGRO PERLA',
        M0F4: 'GRIS ARTENSE',
        M0KU: 'AZUL ENCRE',
        M0PH: 'BEIGE CHRYSTAL PEARL',
        M0VL: 'GRIS PLATINIUM',
        M6N9: 'BLANCO NACAR',
    },
    '1SX8SUNKA1JRA0_SOCHIC': {
        M09V: 'NEGRO PERLA',
        M0F4: 'GRIS ARTENSE',
        M0KU: 'AZUL ENCRE',
        M0PH: 'BEIGE CHRYSTAL PEARL',
        M0VL: 'GRIS PLATINIUM',
        M6N9: 'BLANCO NACAR',
    },
    '1SX8SUNNJ9JRA0_OPERA': {
        M09V: 'NEGRO PERLA',
        M0F4: 'GRIS ARTENSE',
        M0KU: 'AZUL ENCRE',
        M0PH: 'BEIGE CHRYSTAL PEARL',
        M0VL: 'GRIS PLATINIUM',
        M6N9: 'BLANCO NACAR',
    },
    '1SX8SUNNJ9JRA0_SOCHIC': {
        M09V: 'NEGRO PERLA',
        M0F4: 'GRIS ARTENSE',
        M0KU: 'AZUL ENCRE',
        M0PH: 'BEIGE CHRYSTAL PEARL',
        M0VL: 'GRIS PLATINIUM',
        M6N9: 'BLANCO NACAR',
    },
    '1SX8SUNNK2J0A0_SOCHIC': {
        M09V: 'NEGRO PERLA',
        M0F4: 'GRIS ARTENSE',
        M0KU: 'AZUL ENCRE',
        M0PH: 'BEIGE CHRYSTAL PEARL',
        M0VL: 'GRIS PLATINIUM',
        M6N9: 'BLANCO NACAR',
    },
    '1SX8SUTKA1JRL0_LOUVRE': {
        M09V: 'NEGRO PERLA',
        M0KU: 'AZUL ENCRE',
        M0PH: 'BEIGE CHRYSTAL PEARL',
        M0VL: 'GRIS PLATINIUM'
    },
    '1CCESYTMK1JRA0_FEEL': {
        M0F4: 'GRIS ARTENSE',
        M06L: 'AZUL OSCURO',
        M0VL: 'GRIS PLATINIUM'
    },
    '1CLEA5HNP1JRA0_FEEL': {
        M09V: 'NEGRO PERLA'
    },
    '1CCESYWNKAJ0A0_SHINE_PACK': {
        M0VL: 'GRIS PLATINIUM'
    },
    '1CB6A5NMNKJ0A0_LIVE': {
        P0WP: 'BLANCO'
    }
};

export const DEAFULT_COLORS = {
    M09V: 'NEGRO PERLA',
    'M09V/DZK03': 'NEGRO PERLA/BLANCO',
    M0F4: 'GRIS ARTENSE',
    'M0F4/DZK12': 'GRIS ARTENSE/NEGRO',
    'M0F4/DZK02': 'GRIS ARTENSE/BLANCO',
    'M0PH/DZK03': 'BEIGE CHRYSTAL PEARL / BLANCO',
    'M0HZ/DZK03': 'AZUL KANDINSKY / BLANCO',
    'M0PY/DZK03': 'ROJO RUBI / BLANCO',
    'M0HZ/DZK13': 'AZUL KANDINSKY / NEGRO',
    'M0PH/DZK13': 'BEIGE CHRYSTAL PEARL / NEGRO',
    'M0PY/DZK13': 'ROJO RUBI / NEGRO',
    M0VL: 'GRIS PLATINIUM',
    'M0VL/DZK02': 'GRIS PLATINIUM / BLANCO',
    'M0VL/DZK12': 'GRIS PLATINIUM / NEGRO',
    'M6FC/DZK13': 'BLANCO NACAR / NEGRO'
}